import React from 'react';
import { BookingButton } from '../components/BookingButton';
import { TestimonialCard } from '../components/TestimonialCard';
import { Accordion } from '../components/Accordion';
import { testimonials } from '../components/testimonials';
export function QuarterlyMeeting() {
  return <div className="w-full min-h-screen bg-[#F1F5F9] overflow-x-hidden pt-20" data-id="element-958">
      {/* SECTION 1 — HERO OFERTĂ */}
      <section className="w-full bg-[#09111F] relative overflow-hidden py-20 md:py-32 text-center" data-id="element-959">
        <div className="absolute inset-0 opacity-[0.03] bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:24px_24px]" data-id="element-960"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#1D4ED8] opacity-10 blur-[150px] rounded-full pointer-events-none" data-id="element-961"></div>
        <div className="max-w-[900px] mx-auto px-5 md:px-12 relative z-10" data-id="element-962">
          <h1 className="font-['Montserrat'] text-[clamp(40px,5vw,64px)] font-extrabold text-white leading-[1.1] mb-6" data-id="element-963">
            Ședința Trimestrială ProVi
          </h1>
          <p className="font-['Inter'] text-[20px] md:text-[24px] font-light text-[rgba(255,255,255,0.8)] leading-[1.6] mb-10" data-id="element-964">
            O zi de planificare și claritate pentru următoarele 90 de zile, cu
            tine și echipa ta de leadership.
          </p>
          <BookingButton text="Programează o Discuție" href="/contact" className="px-10 py-5 text-[16px]" data-id="element-965" />
        </div>
      </section>

      {/* SECTION 2 — DESCRIERE */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-966">
        <div className="max-w-[800px] mx-auto px-5 md:px-12" data-id="element-967">
          <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F] mb-8 text-center" data-id="element-968">
            Știi că treci din trimestru în trimestru fără o direcție clară.
            Echipa ta simte la fel.
          </h2>
          <div className="space-y-6 font-['Inter'] text-[19px] font-light text-[#4B5563] leading-[1.8]" data-id="element-969">
            <p data-id="element-970">
              Fiecare trimestru începe la fel. Fără o evaluare clară a ce a mers
              și ce nu. Fără un obiectiv clar pe care toți să îl urmeze. Fără
              priorități asumate cu responsabili și termene. Echipa ta intră în
              trimestrul nou cu inerția celui vechi și se întreabă de ce
              rezultatele arată la fel.
            </p>
            <p data-id="element-971">
              Nu ai timp să te oprești o zi din operațional ca să planifici. Sau
              cel puțin asta îți spui. Dar fiecare trimestru fără planificare te
              costă luni de muncă risipită pe lucruri care nu contau cu
              adevărat. Echipa lucrează, dar nu pe ce trebuie. Tu muncești, dar
              nu pe direcție. Și la finalul trimestrului te întrebi iar de ce nu
              s-a mișcat nimic real.
            </p>
            <p className="font-medium text-[#09111F] p-6 bg-[#F1F5F9] rounded-2xl border-l-4 border-[#1D4ED8]" data-id="element-972">
              Ședința Trimestrială ProVi este o zi intensivă de lucru cu Valer
              Dura, cu tine și cu echipa ta de lideri. Într-o singură zi
              analizăm trimestrul anterior, clarificăm obiectivul următor,
              alegem prioritățile și construim planul de acțiune complet. A doua
              zi, echipa ta știe exact ce are de făcut și începe.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 3A — CE FACEM ÎN ZIUA DE PLANIFICARE */}
      <section className="w-full bg-[#F1F5F9] py-16 md:py-24" data-id="element-973">
        <div className="max-w-[1000px] mx-auto px-5 md:px-12" data-id="element-974">
          <div className="text-center mb-16" data-id="element-975">
            <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F] mb-4" data-id="element-976">
              Ce construim împreună în ședința trimestrială
            </h2>
          </div>
          <div className="flex flex-col gap-8 max-w-[720px] mx-auto" data-id="element-977">
            {[{
            title: 'Retrospectiva trimestrului anterior',
            items: ['Evaluăm obiectiv ce s-a realizat din planul anterior: ce s-a implementat, ce nu și de ce', 'Identificăm lecțiile reale ale trimestrului: ce a funcționat, ce am subestimat, ce trebuie schimbat', 'Lăsăm în urmă trimestrul anterior cu totul, fără a trage probleme nerezolvate în trimestrul nou fără o decizie conștientă']
          }, {
            title: 'Clarificarea obiectivului trimestrial',
            items: ['Definim un singur obiectiv clar, concret și măsurabil pe care toată echipa de leadership îl înțelege și îl asumă', 'Aliniem obiectivul trimestrial la viziunea anuală a companiei astfel încât fiecare trimestru construiește spre direcția corectă', 'Testăm obiectivul cu echipa prezentă în sală: dacă nu pot spune în 10 secunde care este obiectivul și ce rol au, nu este suficient de clar']
          }, {
            title: 'Alegerea priorităților și măsurabilelor',
            items: ['Selectăm maximum 3 priorități trimestriale din toate lucrurile pe care le-am putea face, pe baza impactului real', 'Fiecare prioritate primește un responsabil din echipa de lideri, un termen clar și un indicator de succes pe care îl putem măsura', 'Construim tabloul de marcaj trimestrial cu cifrele care arată săptămânal dacă suntem pe drum sau nu']
          }, {
            title: 'Plan de acțiune complet pe o singură pagină',
            items: ['Aducem tot ce am construit în timpul zilei pe o singură foaie: obiectivul, prioritățile, responsabilii, termenele, indicatorii', 'Fiecare lider pleacă din sală știind exact ce are de făcut în primele 2 săptămâni din trimestru', 'Stabilim data și formatul ședințelor săptămânale de urmărire a progresului pe care echipa le conduce singură']
          }].map((block, index) => <div key={index} className="bg-white p-8 rounded-3xl shadow-[0_4px_20px_rgba(0,0,0,0.04)] border border-[rgba(0,0,0,0.04)]" data-id="element-978">
                <div className="w-12 h-12 bg-[#EFF6FF] rounded-xl flex items-center justify-center mb-6 text-[#1D4ED8] font-bold text-xl" data-id="element-979">
                  {index + 1}
                </div>
                <h3 className="font-['Montserrat'] text-[22px] font-bold text-[#09111F] mb-4" data-id="element-980">
                  {block.title}
                </h3>
                <ul className="space-y-3" data-id="element-981">
                  {block.items.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-982">
                      <div className="w-1.5 h-1.5 rounded-full bg-[#1D4ED8] mt-2.5 flex-shrink-0" data-id="element-983"></div>
                      <span className="font-['Inter'] text-[16px] text-[#4B5563] leading-[1.6]" data-id="element-984">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </div>)}
          </div>
        </div>
      </section>

      {/* SECTION 4 — BENEFICII */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-985">
        <div className="max-w-[1200px] mx-auto px-5 md:px-12" data-id="element-986">
          <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F] mb-12 text-center" data-id="element-987">
            Cu ce pleci după ședința trimestrială
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-988">
            {[{
            title: 'Un obiectiv trimestrial clar',
            desc: "Nu mai intri în trimestru cu 'să vedem'. Ai o direcție pe care orice om din echipă o poate spune în 10 secunde."
          }, {
            title: '3 priorități concrete',
            desc: 'Nu 15 lucruri de făcut. 3 lucruri care contează cu adevărat, fiecare cu un om care răspunde de ele.'
          }, {
            title: 'Tabloul de marcaj configurat',
            desc: 'Cifrele care contează, gata de urmărit săptămânal din prima zi a trimestrului nou.'
          }, {
            title: 'Decizii luate care altfel ar fi fost amânate',
            desc: "Într-o zi, cu toți liderii în sală și cu Valer care facilitează, se iau deciziile care de luni de zile stau pe lista de 'trebuie să vorbim despre asta'."
          }, {
            title: 'Echipă aliniată și responsabilizată',
            desc: 'Liderii tăi pleacă din sală știind exact ce au de făcut. Nu mai așteaptă instrucțiuni de la tine. Au asumat public, în fața celorlalți.'
          }, {
            title: 'Plan complet pe o pagină',
            desc: 'Totul încape pe o singură foaie. Obiectivul, prioritățile, responsabilii, termenele, indicatorii. Vizibil pe peretele biroului sau în Drive-ul echipei.'
          }].map((benefit, i) => <div key={i} className="bg-[#F1F5F9] rounded-2xl p-6 border border-[rgba(0,0,0,0.04)]" data-id="element-989">
                <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center mb-4 text-[#1D4ED8] shadow-sm" data-id="element-990">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-991">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-992"></path>
                  </svg>
                </div>
                <h3 className="font-['Montserrat'] text-[18px] font-bold text-[#09111F] mb-2" data-id="element-993">
                  {benefit.title}
                </h3>
                <p className="font-['Inter'] text-[15px] text-[#4B5563] leading-[1.6]" data-id="element-994">
                  {benefit.desc}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* SECTION 5 — CINE SUNT EU */}
      <section className="w-full bg-[#0A1628] py-16 md:py-24 text-white" data-id="element-995">
        <div className="max-w-[800px] mx-auto px-5 md:px-12 text-center" data-id="element-996">
          <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold mb-8" data-id="element-997">
            Cine facilitează ședința și de ce contează un om din afara companiei
          </h2>
          <div className="space-y-6 font-['Inter'] text-[19px] font-light text-[rgba(255,255,255,0.8)] leading-[1.8] text-left" data-id="element-998">
            <p data-id="element-999">
              Sunt Valer Dura. Am construit, eficientizat și vândut propriile
              afaceri cu cifre de milioane de euro. De 12 ani facilitez sesiuni
              de planificare trimestrială și anuală cu antreprenori și echipe de
              lideri din companii românești.
            </p>
            <p data-id="element-1000">
              Ședințele de planificare facilitate de antreprenor în propria
              echipă rareori funcționează. Ești prea aproape de problemă ca să o
              vezi clar. Ești prea implicat emoțional ca să rămâi obiectiv. Și
              echipa ta se comportă diferit când șeful facilitează decât când o
              face cineva din exterior care nu are agenda ascunsă.
            </p>
            <p data-id="element-1001">
              Eu vin ca om neutru cu un singur scop: să ieșiți din acea zi cu un
              plan real, asumat de toți, gata de implementat. Pun întrebările pe
              care nimeni din interior nu le pune. Aduc pe masă subiectele pe
              care le evitați. Și mă asigur că fiecare decizie luată în sală are
              un responsabil, un termen și un mod de a fi verificată.
            </p>
            <p className="font-medium text-white border-l-4 border-[#3B82F6] pl-6 py-2" data-id="element-1002">
              Nu facilitez ședințe în care oamenii se simt bine dar pleacă fără
              nimic concret. Facilitez ședințe din care pleci cu un plan pe care
              îl execuți a doua zi.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 6 — PENTRU CINE ESTE / NU ESTE */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-1003">
        <div className="max-w-[1000px] mx-auto px-5 md:px-12" data-id="element-1004">
          <div className="grid md:grid-cols-2 gap-8" data-id="element-1005">
            <div className="bg-[#EFF6FF] rounded-3xl p-8 border border-[rgba(59,130,246,0.2)]" data-id="element-1006">
              <h3 className="font-['Montserrat'] text-[24px] font-bold text-[#09111F] mb-6 flex items-center gap-3" data-id="element-1007">
                <div className="w-8 h-8 rounded-full bg-[#1D4ED8] text-white flex items-center justify-center" data-id="element-1008">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-1009">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-1010"></path>
                  </svg>
                </div>
                Ședința trimestrială este pentru tine dacă:
              </h3>
              <ul className="space-y-4" data-id="element-1011">
                {['Ai o echipă de minimum 3 lideri și intri în fiecare trimestru fără un plan clar pe care toți să îl urmeze', 'Simți că echipa ta lucrează mult dar nu pe ce trebuie și ai nevoie de o zi în care puneți lucrurile în ordine', 'Ai decizii amânate de luni de zile pe care nu reușești să le iei singur și ai nevoie de un cadru structurat'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-1012">
                    <div className="w-2 h-2 rounded-full bg-[#1D4ED8] mt-2 flex-shrink-0" data-id="element-1013"></div>
                    <span className="font-['Inter'] text-[17px] text-[#4B5563] leading-[1.6]" data-id="element-1014">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
            <div className="bg-[#FEF2F2] rounded-3xl p-8 border border-[rgba(239,68,68,0.2)]" data-id="element-1015">
              <h3 className="font-['Montserrat'] text-[24px] font-bold text-[#09111F] mb-6 flex items-center gap-3" data-id="element-1016">
                <div className="w-8 h-8 rounded-full bg-[#EF4444] text-white flex items-center justify-center" data-id="element-1017">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-1018">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" data-id="element-1019"></path>
                  </svg>
                </div>
                Ședința trimestrială nu este pentru tine dacă:
              </h3>
              <ul className="space-y-4" data-id="element-1020">
                {['Nu ai echipă de lideri, ședința este construită pentru antreprenor plus minimum 2-3 lideri de departamente', 'Cauți o sesiune de coaching individual, pentru asta există diagnosticul sau implementarea 1 la 1', 'Nu ești pregătit să iei decizii în acea zi, ședința produce rezultate doar dacă vii dispus să decizi, nu doar să discuți'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-1021">
                    <div className="w-2 h-2 rounded-full bg-[#EF4444] mt-2 flex-shrink-0" data-id="element-1022"></div>
                    <span className="font-['Inter'] text-[17px] text-[#4B5563] leading-[1.6]" data-id="element-1023">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 7 — RECAPITULARE INVESTIȚIE */}
      <section className="w-full bg-[#F1F5F9] py-16 md:py-24" data-id="element-1024">
        <div className="max-w-[1000px] mx-auto px-5 md:px-12" data-id="element-1025">
          <div className="bg-white rounded-3xl p-8 md:p-12 border-2 border-[#1D4ED8] shadow-[0_20px_40px_rgba(29,78,216,0.08)] relative" data-id="element-1026">
            <div className="absolute -top-4 inset-x-0 flex justify-center" data-id="element-1027">
              <span className="bg-[#1D4ED8] text-white font-['Montserrat'] text-[12px] font-bold tracking-[0.15em] uppercase px-6 py-2 rounded-full shadow-md" data-id="element-1028">
                RECAPITULARE
              </span>
            </div>
            <h2 className="font-['Montserrat'] text-[28px] md:text-[36px] font-bold text-[#09111F] mb-8 text-center mt-4" data-id="element-1029">
              Hai să recapitulăm ce primești în Ședința Trimestrială
            </h2>

            <div className="flex flex-col gap-12" data-id="element-1030">
              <div data-id="element-1031">
                <h3 className="font-['Montserrat'] text-[20px] font-bold text-[#1D4ED8] mb-6 border-b pb-2" data-id="element-1032">
                  Ce este inclus:
                </h3>
                <ul className="space-y-4" data-id="element-1033">
                  {['O zi completă de lucru facilitată de Valer Dura cu tine și echipa ta de lideri (Valoare: 2.500 €)', 'Pregătire prealabilă: Valer analizează datele companiei și chestionarele completate de echipă înainte de sesiune (Valoare: 500 €)', 'Toate instrumentele de planificare: tablou de marcaj, plan trimestrial, lista de priorități, formatul de ședință săptămânală (Valoare: 295 €)', 'Raport de sesiune trimis în 48 de ore: deciziile luate, planul complet, acțiunile cu responsabili și termene'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-1034">
                      <svg className="w-5 h-5 text-[#1D4ED8] flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-1035">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-1036"></path>
                      </svg>
                      <span className="font-['Inter'] text-[15px] text-[#4B5563] leading-[1.6]" data-id="element-1037">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </div>
              <div data-id="element-1038">
                <div className="bg-[#F1F5F9] rounded-xl p-6 text-center border border-[rgba(0,0,0,0.05)] h-full flex flex-col justify-center" data-id="element-1039">
                  <p className="font-['Inter'] text-[15px] text-[#6B7280] line-through mb-1" data-id="element-1040">
                    Valoare totală reală: 3.295 €
                  </p>
                  <p className="font-['Montserrat'] text-[40px] font-bold text-[#09111F] mb-2" data-id="element-1041">
                    2.500 €
                  </p>
                  <p className="font-['Inter'] text-[13px] text-[#4B5563] mt-1" data-id="element-1042">
                    Se programează pe baza disponibilității cu minimum 2
                    săptămâni în avans.
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-12 text-center" data-id="element-1043">
              <BookingButton text="Programează o Discuție" href="/contact" className="px-10 py-5 text-[16px] w-full sm:w-auto" data-id="element-1044" />
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 8 — TESTIMONIALE */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-1045">
        <div className="max-w-[1200px] mx-auto px-5 md:px-12" data-id="element-1046">
          <div className="text-center mb-16" data-id="element-1047">
            <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F]" data-id="element-1048">
              Ce spun antreprenorii după prima ședință trimestrială ProVi
            </h2>
          </div>
          <div className="grid md:grid-cols-3 gap-8" data-id="element-1049">
            {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-1050" />)}
          </div>
        </div>
      </section>

      {/* SECTION 9 — ÎNTREBĂRI FRECVENTE */}
      <section className="w-full bg-[#F1F5F9] py-16 md:py-24" data-id="element-1051">
        <div className="max-w-[1000px] mx-auto px-5 md:px-12" data-id="element-1052">
          <div className="text-center mb-16" data-id="element-1053">
            <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F]" data-id="element-1054">
              Întrebări Frecvente
            </h2>
          </div>
          <Accordion items={[{
          question: 'Ședința se face online sau fizic?',
          answer: 'Poate fi în ambele formate. Ședințele online se fac prin Zoom cu Miro Board pentru lucru colaborativ. Ședințele fizice se fac la sediul companiei tale. Ambele variante au același format și produc aceleași rezultate. Prețul este identic indiferent de format.'
        }, {
          question: 'Cine participă la ședință?',
          answer: 'Tu ca antreprenor plus echipa ta de leadership: directorii de departamente, managerii, cofondatorii. Ideal între 3 și 8 persoane. Sub 3 nu ai suficiente perspective. Peste 8 ședința devine greu de facilitat eficient.'
        }, {
          question: 'Cât durează o ședință trimestrială?',
          answer: 'O zi completă de lucru: 6 până la 8 ore, cu pauze incluse. Nu se comprimă în 2-3 ore. Planificarea trimestrială serioasă cere timp. O zi pe trimestru investită în planificare economisește săptămâni de muncă pe direcția greșită.'
        }, {
          question: 'Ce trebuie să pregătesc înainte?',
          answer: 'Cu 2 săptămâni înainte de ședință, Valer trimite un chestionar de pregătire pentru tine și pentru fiecare lider. Completarea durează 15-20 de minute per persoană. Pe baza răspunsurilor, Valer pregătește agenda personalizată a ședinței.'
        }, {
          question: 'Pot programa ședințe trimestriale recurente?',
          answer: 'Da. Mulți antreprenori care fac prima ședință trimestrială aleg să o repete la fiecare 90 de zile. Se poate contracta un pachet de 4 ședințe trimestriale pe an cu un preț preferențial. Detaliile se discută după prima ședință.'
        }, {
          question: 'Cum e diferit față de ProVi Sprint sau implementarea de 12 luni?',
          answer: 'Ședința trimestrială este o intervenție de o zi concentrată pe planificarea unui singur trimestru. ProVi Sprint este un program de 12 săptămâni de implementare a întregului sistem. Implementarea de 12 luni include ședințele trimestriale plus sesiuni lunare și lucru continuu. Ședința trimestrială poate fi punctul de start sau poate fi cumpărată separat de clienții care vor doar ritmul trimestrial.'
        }, {
          question: 'Ce se întâmplă dacă echipa mea nu respectă planul după ședință?',
          answer: 'Bonus-ul de check-in la 30 de zile este exact pentru asta. Valer verifică cu tine progresul pe priorități și identifică blocajele apărute. Dacă echipa nu respectă planul, aceasta este o informație valoroasă: arată exact unde e problema reală, fie în asumarea inițială, fie în competențe, fie în cultura echipei.'
        }]} data-id="element-1055" />
        </div>
      </section>
    </div>;
}